import './styles/component.custom-select.scss';
import { isNullOrUndef } from '../js/helpers/isNullOrUndef';
import { isNotNullOrUndef } from '../js/helpers/isNotNullOrUndef';
class ComponentCustomSelect extends HTMLElement {
    selectElement;
    customSelectElement;
    customSelectPlaceholder;
    customSelectPlaceholderText;
    customSelectOptions;
    connectedCallback() {
        this.selectElement = this.querySelector('select');
        this.customSelectElement = this.querySelector('.custom-select-js');
        this.customSelectPlaceholder = this.querySelector('.custom-select_placeholder-js');
        this.customSelectPlaceholderText = this.querySelector('.custom-select_placeholder-js span');
        this.customSelectOptions = this.querySelectorAll('.custom-select_option-js');
        if (isNullOrUndef(this.selectElement) ||
            isNullOrUndef(this.customSelectElement) ||
            isNullOrUndef(this.customSelectPlaceholder))
            return;
        this.init();
    }
    init() {
        this.customSelectPlaceholder.addEventListener('click', this.toggle.bind(this));
        this.customSelectOptions.forEach((item, index) => {
            item.addEventListener('click', () => {
                this.close();
                this.selectElement.options[index].selected = true;
                this.customSelectPlaceholderText.innerText = item.innerText;
                this.updateActiveItem(index);
            });
        });
        const closestForm = this.closest('form');
        if (isNullOrUndef(closestForm))
            return;
        closestForm.addEventListener('reset', () => {
            this.updateActiveItem(0);
            this.customSelectPlaceholderText.innerText = this.customSelectOptions[0].innerText;
        });
    }
    updateActiveItem(activeItemIndex) {
        this.customSelectOptions.forEach((item, index) => {
            item.dataset.selected = String(index === activeItemIndex);
        });
    }
    open() {
        this.customSelectElement.dataset.closed = 'false';
        document.body.addEventListener('click', this.handlerBodyClickBound, true);
    }
    handlerBodyClick(event) {
        const target = event.target;
        if (isNotNullOrUndef(target.closest('custom-select-component')))
            return;
        this.close();
    }
    handlerBodyClickBound = this.handlerBodyClick.bind(this);
    close() {
        this.customSelectElement.dataset.closed = 'true';
        document.body.removeEventListener('click', this.handlerBodyClickBound, true);
    }
    toggle() {
        this.customSelectElement.dataset.closed === 'true' ? this.open() : this.close();
    }
}
customElements.define('custom-select-component', ComponentCustomSelect);
